/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { Stack, OutlinedTextFieldProps, Typography, SxProps, Theme } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ko';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DateValidationError } from '@mui/x-date-pickers';

dayjs.extend(utc);
dayjs.extend(timezone);

interface IDialogDatePickerProps extends Partial<OutlinedTextFieldProps> {
  label?: string;
  labelWidth?: number | string;
  marginBottom?: string;
  value: any;
  name: string;
  minDate?: Date | undefined;
  handleDateChange: (name: string, value: any) => void;
  handleDateError: (name: string, value: DateValidationError) => void;
  errorMessage?: string;
}

function DialogDatePicker({
  label,
  labelWidth = '100px',
  marginBottom = '20px',
  value,
  name,
  handleDateChange,
  handleDateError,
  minDate = undefined,
  errorMessage,
}: IDialogDatePickerProps) {
  // console.log('value1', dayjs.tz(value, 'Asia/Seoul'), value?.format('YYYYMMDD'));
  const labelStyle: SxProps<Theme> = {
    color: 'mind.black.A0',
    minWidth: labelWidth,
    maxWidth: labelWidth,
    typography: 's13w800',
  };

  const handleChange = (newValue: any) => {
    handleDateChange(name, newValue);
  };

  const handleError = (newValue: any) => {
    handleDateError(name, newValue);
  };

  return (
    <Stack
      sx={{ marginBottom, width: '100%', pt: '0px!important' }}
      spacing="8px"
      direction={{ xs: 'column', sm: 'column', md: 'row' }}
      alignItems="flex-satrt"
    >
      {label && (
        <Typography
          sx={{
            ...labelStyle,
            maxWidth: { xs: '100%', sm: '100%', md: labelWidth },
            width: { xs: '100%', sm: '100%', md: labelWidth },
            marginTop: '12px!important',
          }}
          noWrap
        >
          {label}
        </Typography>
      )}

      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
        <DemoContainer components={['DatePicker']} sx={{ pt: 0 }}>
          <DatePicker
            closeOnSelect={false}
            value={value || null}
            format="YYYY-MM-DD"
            onChange={handleChange}
            onError={handleError}
            slotProps={{
              actionBar: {
                actions: ['accept'],
              },
              textField: {
                helperText: errorMessage,
                sx: {
                  '& .MuiOutlinedInput-input': {
                    p: '10px 16px',
                  },
                },
              },
            }}
            minDate={minDate}
          />
        </DemoContainer>
      </LocalizationProvider>
    </Stack>
  );
}

export default memo(DialogDatePicker);
